/* eslint-disable linebreak-style */
import Vue from 'vue';
import './plugins/ant-design';
import './plugins/moment';
import './plugins/axios';
import './plugins/sentry';
import auth from './plugins/auth';
import i18n from './plugins/i18n';
import App from './App.vue';
import router from './plugins/vue-router';
import store from './store';

require('./assets/css/override.css');

Vue.config.productionTip = false;
Vue.prototype.$authorization = auth;

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
